var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",class:{'full-screen': _vm.isFullScreen}},[_c('header',[_vm._t("header")],2),_c('div',{staticClass:"main"},[_vm._t("default")],2),_c('footer',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }